<script lang="ts" setup>
import { PageHero } from '~/components';
import { SupportRow, SupportShell } from '~/components/support';

definePageMeta({ layout: 'default' });

useHead({ title: 'About' });
useSeoMeta({
  description:
    'About VoteWise — read the terms of service and the privacy policy.',
  ogTitle: 'About | VoteWise',
  ogDescription:
    'About VoteWise — read the terms of service and the privacy policy.',
});
</script>

<template>
  <div class="about-page">
    <PageHero constrained max-width="max-w-[1200px]">
      <div class="about-page__panel" data-testid="about-page">
        <SupportShell heading="About" flush-on-mobile>
          <SupportRow
            label="Terms of Service"
            to="/terms-of-use"
            testid="about-terms-of-use"
          />
          <SupportRow
            label="Privacy Policy"
            to="/privacy-policy"
            testid="about-privacy-policy"
          />
        </SupportShell>
      </div>
    </PageHero>
  </div>
</template>

<style scoped lang="scss">
.about-page {
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
  min-height: calc(100vh - var(--header-height));

  &__panel {
    display: flex;
    flex-direction: column;
  }
}
</style>
